<template>
	<div>
		<div class="app">
			<router-view></router-view>
		</div>

	</div>
</template>

<script>
	import Api from '@/utils/api'
	export default {
		data() {
			return {
				footerDisplay: false
			}
		},
		async mounted() {
			Api.reportedData();
		}
	}
</script>
<style lang="scss">
	@import '@/common/common'

</style>
